<template>
  <div id="top_nav" class="relativeItem">
    <!--标题-->
    <div
      class="title c-bk relativeItem"
      :style="{ paddingTop: padding_top + 'px' }"
      :class="{ noHeight: !inapp || show == '2' }"
    >
      <div class="top-main flex-box relativeItem">
        <img
          src="../../assets/backIcon.png"
          class="back-arrow"
          @click="to_pre"
          v-if="back && dark"
        />
        <img
          src="../../assets/iconback.png"
          class="back-arrow"
          @click="to_pre"
          v-else-if="back"
        />
        <p
          class="car-title apostrophe absoluteItem centerImg"
          :class="{ waite_color: dark, fontWeight: font400 }"
        >
          {{ title }}
        </p>

        <!--各种图标功能-->
        <!--特权设置-->
        <img
          src="../../assets/tqsz.png"
          class="imgBlock news"
          v-if="to_tqsz"
          @click="action(0)"
        />
        <!--说明字样-->
        <span class="text-tip absoluteItem centerY" @click="action(1)" v-if="hydjsm"
          >说明</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top_nav",
  props: [
    "font400", //非粗字体
    "hydjsm", //是否跳转活跃等级说明
    "to_tqsz", //前往特权设置页面
    "no_right", //取消右上角的菜单
    "closeweb", //是否关闭webview
    "show", //是否显示导航
    "share", //当前页面是否支持分享
    "typeName", //是否在顶部显示搜索框
    "imgTitle", //标题是否为图片形式
    "imgTitleUrl", //图片标题的url地址
    "vuePage", //当前vue模板的id
    "title", //文字标题内容
    "ext_height", //额外的高度，个别页面有定位在顶部的导航的高度
    "back", //是否显示返回按钮
    "dark", //是否为深色背景
    "news", //是否显示消息图标
    "imgTiW", //图片title的宽度 是百分比
    "backcolor", //背景颜色
    "position", //导航的定位方式
    "setHeight", //自定义顶部高度
  ],
  data() {
    return {
      padding_top: 20, //导航顶部padding
      inapp: true,
      show_jihe: false, //是否显示动作集合
      show_address: false, //是否显示收货地址
      in_android: false, //判断是否在安卓
    };
  },
  methods: {
    /**前往购物车 */
    to_car() {
      this.$router.push({ path: "/zscar" });
    },

    /**动作集合触发 */
    action(index) {
      if (index === 0) {
        //前往特权设置
        this.$router.push({ path: "/gradetesetting" });
      } else if (index === 1) {
        //跳活跃等级说明
        this.$router.push({ path: "/gradehuoyueexplain" });
      }
    },

    /**返回上一页 */
    to_pre() {
      if (this.closeweb) {
        this.$appAc.closeWeb();
      } else {
        //先判断url地址是否能返回
        if (window.history.length <= 1) {
          this.$appAc.closeWeb();
        } else {
          this.$router.go(-1);
          let _this = this;
          this.$tool.nav_jishiqi = setTimeout(() => {
            _this.$appAc.closeWeb();
          }, 600);
        }
      }
    },

    /**设置顶部padding */
    set_top_padding() {
      if (!this.inapp && this.typeName != "top-search") {
        return false;
      }
      //如果有setHeight参数 就不需要设置 直接用该值作为固定高度即可
      if (this.setHeight != undefined) {
        document.querySelector(this.vuePage).style.paddingTop = this.setHeight + "px";
      } else {
        let obj = document.querySelector("#top_nav");
        if (this.ext_height) {
          document.querySelector(this.vuePage).style.paddingTop =
            obj.offsetHeight + this.ext_height * 1 + "px";
        } else {
          document.querySelector(this.vuePage).style.paddingTop = obj.offsetHeight + "px";
        }
      }
    },

    /**获取消息 */

    /**判断颜色是否为深色和浅色，通知app改变topbar的颜色 */
    is_dark() {
      if (this.dark) {
        this.$appAc.topbar_color(1);
      } else {
        this.$appAc.topbar_color(0);
      }
    },

    /**判断是否有设置背景颜色 */
    is_bkcolor() {
      if (this.backcolor) {
        document.querySelector(".c-bk").style.background = this.backcolor;
      }
    },

    /**判断是否有指定posotion定位方式 */
    is_position() {
      if (this.position) {
        document.querySelector("#top_nav").style.position = this.position;
      }
    },

    /**从ios获取设备topbar的高度 */
    getStatusBarHeight(val) {
      this.padding_top = val;
      let _this = this;
      setTimeout(() => {
        _this.set_top_padding();
      }, 400);
    },
  },
  mounted: function () {
    //将getStatusBarHeight赋予window，便于app调用
    window["getStatusBarHeight"] = (val) => {
      this.getStatusBarHeight(val);
    };
    let _this = this;
    if (_this.$cookie.getC("platform") == "app" || _this.$tool.in_third) {
      _this.inapp = true;
      //这个计时器是防止浏览器没有找到APP里面的get_top_bar_height方法
      //倒是个别页面顶部会被遮住无法进行操作
      let js = setTimeout(() => {
        _this.set_top_padding();
      }, 500);
      _this.padding_top = _this.$appAc.get_top_bar_height();
      //如果浏览器找到了APP的get_top_bar_height方法
      //就立马清除计时器，导航高度使用app返回的值
      clearTimeout(js);
      if (_this.$tool.isAorI() == "Android") {
        setTimeout(() => {
          _this.set_top_padding();
        }, 400);
      }
    } else {
      _this.inapp = false;
      setTimeout(() => {
        _this.set_top_padding();
      }, 400);
    }
    this.is_dark();
    this.is_bkcolor();
    this.is_position();
  },
};
</script>

<style scoped>
#top_nav {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
}
.c-bk {
  position: relative;
  width: 100%;
  background: #fff;
  z-index: 3;
}
.top-main {
  justify-content: space-between;
  padding: 10px 16px 10px 16px;
  align-items: center;
}
.noHeight {
  height: 0;
  padding: 0 !important;
  overflow: hidden;
}
.search {
  width: 80%;
}
.width100 {
  width: 100%;
}
.width90 {
  width: 90%;
}
.news {
  width: 22px;
}
.back-arrow {
  width: 22px;
}
.car {
  width: 22px;
  margin-right: 16px;
}
.dian {
  width: 22px;
}
.two_item {
  align-items: center;
  right: 0;
}
.text-tip {
  font-size: 14px;
  right: 16px;
}

/**购物车 */
.title {
  font-size: 18px;
  text-align: center;
}
.fontWeight {
  font-weight: 400;
}
.title .news {
  bottom: 8px;
}
.img-title {
  margin: 0 auto;
}
.waite_color {
  color: #fff;
}
.car-title {
  width: 50%;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.car-title img {
  width: 18px;
  height: 18px;
  margin-left: 4px;
}

/**收货地址弹窗 */
.address_tc .main {
  width: 100%;
  bottom: 0;
  height: 60vh;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: #fff;
  animation: show 0.4s forwards;
  z-index: 21;
}
.address_tc h3 {
  text-align: center;
  font-size: 18px;
  padding: 15px 0 10px 0;
}

/**动作集合 */
.jihe {
  position: absolute;
  top: -150%;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
  right: 10px;
  z-index: 2;
  border-radius: 4px;
}
.jihe li {
  width: 96px;
  padding: 13px 0;
  font-size: 12px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.jihe li img {
  width: 16px;
  height: 16px;
  margin-right: 14px;
}
.jihe li:last-child {
  border: 0;
}
.jihe .sanjiao {
  width: 14px;
  top: -7px;
  right: 8px;
}
.show_jihe {
  top: 116%;
}
</style>
